import { getIn } from 'formik';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { Flex, Box, Text } from 'rebass';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { TextFieldWrap, Label, ErrorMessageWrap } from './styled';
import { FaInfoCircle } from "react-icons/fa";

const TextField = ({ field, subText, form, placeholder, label, showError, type = "input", borderRadius, showTextArea = false, pl, autoFocus, ...props }) => {
  const scrollToItemRef = useRef()

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const { fontSize } = props;
  const [showPassword, setShowPassword] = useState(false)

  function togglePasswordVisibility() {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    if (showError && error && touched && scrollToItemRef.current) {
      scrollToItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, [showError, error, touched, scrollToItemRef?.current]);

  const handleChange = (e) => {
    if (field.name === 'gift-certificate') {
      let rawValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
      let maskedValue = '';

      if (rawValue.length > 0) {
        maskedValue += rawValue.slice(0, 4);
      }
      if (rawValue.length > 4) {
        maskedValue += '-' + rawValue.slice(4, 8);
      }
      if (rawValue.length > 8) {
        maskedValue += '-' + rawValue.slice(8, 12);
      }
      e.target.value = maskedValue.toUpperCase()
    }

    field.onChange(e)
  };

  return (
    <TextFieldWrap ref={scrollToItemRef} error={showError && error && touched} {...props}>
      {label && <Label {...field}>{label}</Label>}
      <Flex>
        {showTextArea ? <textarea
          {...field}
          placeholder={placeholder || ''}
          type={type}
          autoComplete="off"
          rows="10"
          style={{ width: '100%', borderRadius, padding: '8px' }}
        /> : <input
          {...field}
          onChange={handleChange}
          autoFocus={autoFocus}
          placeholder={placeholder || ''}
          type={showPassword ? 'text' : type}
          autoComplete="off"
          style={{ width: '100%', borderRadius, paddingLeft: pl, transition: 'height 0.3s ease, box-shadow 0.3s ease' }}
          className="dynamic-height-input"
        />}
        {type === 'password' && (
          showPassword ? <Box as={FiEyeOff} onClick={togglePasswordVisibility} sx={{ cursor: 'pointer' }} ml="-30px" mt="15px" /> : <Box as={FiEye} onClick={togglePasswordVisibility} sx={{ cursor: 'pointer' }} ml="-30px" mt="15px" />
        )}
      </Flex>
      {subText && <Flex mt="4px">
        <Text as={FaInfoCircle} color="#B0B0B0" size={14} minWidth={14} />
        <Text
          ml={1}
          sx={{
            color: '#B0B0B0',
            fontFeatureSettings: "'liga' off, 'calt' off",
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '16px',
          }}
        >{subText}</Text>
      </Flex>}
      {showError && error && touched && (
        <ErrorMessageWrap maxWidth="max-content" {...field} fontSize={fontSize * 0.9}>
          {error}
        </ErrorMessageWrap>
      )}
    </TextFieldWrap>
  );
};

TextField.propTypes = {
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.number,
  fontSize: PropTypes.number,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
};

TextField.defaultProps = {
  width: 320,
  borderRadius: 31,
  fontSize: 16,
  label: '',
  placeholder: '',
  showError: false,
};

export default TextField;
